import actions from './constants';

export const fetchCollectionDatasets = (category, code, page, pageSize, append) => ({
  type: actions.FETCH_COLLECTION_DATASETS,
  category,
  code,
  page,
  pageSize,
  append,
});

export const showCollectionDatasetsResults = (
  category,
  code,
  name,
  permissions,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_COLLECTION_DATASETS_RESULTS,
  category,
  code,
  name,
  permissions,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showCollectionDatasetsError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.SHOW_COLLECTION_DATASETS_ERROR,
});

export const updateCollectionDatasetsFlags = (category, code, { privateFlag, internalFlag, publicFlag }) => ({
  type: actions.UPDATE_COLLECTION_DATASETS_FLAGS,
  category,
  code,
  privateFlag,
  internalFlag,
  publicFlag,
});

export const updateCollectionDatasetsFilter = (category, code, value) => ({
  type: actions.UPDATE_COLLECTION_DATASETS_FILTER,
  category,
  code,
  value,
});

export const toggleCollectionDatasetSelected = (category, code, datasetCode) => ({
  type: actions.TOGGLE_COLLECTION_DATASET_SELECTED,
  category,
  code,
  datasetCode,
});

export const toggleCollectionDatasetsSelected = (category, code, selected) => ({
  type: actions.TOGGLE_COLLECTION_DATASETS_SELECTED,
  category,
  code,
  selected,
});

export const removeCollectionDatasets = (category, code, items) => ({
  type: actions.REMOVE_COLLECTION_DATASETS,
  category,
  code,
  items,
});

export const removeCollectionDatasetsSuccess = (category, code, collection, datasets) => ({
  type: actions.REMOVE_COLLECTION_DATASETS_SUCCESS,
  category,
  code,
  collection,
  items: datasets,
});

export const removeCollectionDatasetsError = (code, name, datasets) => ({
  type: actions.REMOVE_COLLECTION_DATASETS_ERROR,
  code,
  name,
  items: datasets,
});

export const showAddCollectionDatasets = (category, code, name) => ({
  type: actions.SHOW_ADD_COLLECTION_DATASETS,
  category,
  code,
  name,
});

export const hideAddCollectionDatasets = (category, code) => ({
  type: actions.HIDE_ADD_COLLECTION_DATASETS,
  category,
  code,
});

export const fetchCollectionDatasetsAssignable = (category, code, filter) => ({
  type: actions.FETCH_COLLECTION_DATASETS_ASSIGNABLE,
  category,
  code,
  filter,
});

export const updateCollectionUnassignedDatasetsProperties = (category, code, properties) => ({
  type: actions.UPDATE_COLLECTION_UNASSIGNED_DATASETS_PROPERTIES,
  category,
  code,
  properties,
});

export const fetchCollectionDatasetsAssignableSuccess = (category, code, results, resultsCount) => ({
  type: actions.FETCH_COLLECTION_DATASETS_ASSIGNABLE_SUCCESS,
  category,
  code,
  results,
  resultsCount,
});

export const fetchCollectionDatasetsAssignableError = (category, code, error) => ({
  type: actions.FETCH_COLLECTION_DATASETS_ASSIGNABLE_ERROR,
  category,
  code,
  error,
});

export const updateCollectionDatasetsAssignableProperties = (properties) => ({
  type: actions.UPDATE_COLLECTION_DATASETS_ASSIGNABLE_PROPERTIES,
  properties,
});

export const addCollectionDatasetsAssignable = (category, code) => ({
  type: actions.ADD_COLLECTION_DATASETS_ASSIGNABLE,
  category,
  code,
});

export const addCollectionDatasets = () => ({
  type: actions.ADD_COLLECTION_DATASETS,
});

export const addCollectionDatasetSuccess = (code, collection, datasets) => ({
  type: actions.ADD_COLLECTION_DATASETS_SUCCESS,
  code,
  collection,
  items: datasets,
});

export const addCollectionDatasetError = (code, name, datasets) => ({
  type: actions.ADD_COLLECTION_DATASET_ERROR,
  code,
  name,
  datasets,
});

export const removeCollectionDatasetAssignable = (category, code, datasetCode) => ({
  type: actions.REMOVE_COLLECTION_DATASET_ASSIGNABLE,
  category,
  code,
  datasetCode,
});

export const toggleCollectionDatasetColumnOrderBy = (category, code, orderByColumn) => ({
  type: actions.TOGGLE_COLLECTION_DATASET_COLUMN_ORDER_BY,
  category,
  code,
  orderByColumn,
});

export const toggleCollectionDatasetsSingleSorting = (category, code) => ({
  type: actions.TOGGLE_COLLECTION_DATASET_SINGLE_SORTING,
  category,
  code,
});
